<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title> {{ isNewAgreement ? 'Offer a new' : 'Update' }} agreement </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="form"
  data-testid="agreement-form-step2"
>
  <!-- Agreement Create / Edit Details -->
  <div class="ion-margin-top ion-margin-horizontal">
    <app-agreement-status-chip [agreementStatus]="agreement.status"></app-agreement-status-chip>
  </div>
  <ion-item
    *ngIf="consumer"
    lines="none"
    class="listItem"
  >
    <user-avatar-gql
      [avatar]="consumer?.avatar"
      [name]="consumer?.displayName"
      avatarSize="small"
    >
    </user-avatar-gql>
    <ion-label>
      <h2 class="large">{{ consumer?.displayName }}</h2>
      <p>{{ consumer?.profile?.typeOfCare }}</p>
    </ion-label>
    <ion-icon
      name="id-card"
      color="purple-400"
      slot="end"
      [userId]="consumer.id"
      appViewOtherUserProfile
    >
    </ion-icon>
  </ion-item>

  <form
    [formGroup]="form"
    novalidate
  >
    <!-- Service description -->
    <app-agreement-support-services-form
      [agreedService]="form.get('agreedService').value"
      [hasSubmitted]="hasSubmitted"
      (valueChange)="onServiceDescriptionChange($event)"
    ></app-agreement-support-services-form>

    <!-- Dates and Times -->
    <ng-container *ngIf="showDaysAndTimes">
      <h2 class="h3 ion-margin-horizontal">Dates and times</h2>
      <p class="ion-no-margin ion-margin-horizontal">
        Adding agreed dates, days, and times for your support sessions helps avoid confusion about when you’ll provide
        support. Once in an agreement, you can plan and manage dates and times in the calendar.
      </p>
      <mable-input
        label="Select job type"
        [hasError]="form.controls.jobFrequency.showError()"
        (ionInput)="setOrResetValue($event)"
        *ngIf="!this.agreement?.job"
      >
        <ion-select
          aria-label="Select job type"
          formControlName="jobFrequency"
        >
          <ion-select-option value="ongoing">Ongoing</ion-select-option>
          <ion-select-option value="once_off">One-off</ion-select-option>
        </ion-select>
        <div class="warn">
          <p *ngIf="form.get('jobFrequency').errors?.required">Please select a job type.</p>
        </div>
      </mable-input>
      <mable-input
        label="Have you agreed on dates and times?"
        [noBorder]="true"
        [hasError]="form.controls.agreedOnSchedule.showError()"
      >
        <mb-radio-group
          [options]="options"
          size="medium"
          formControlName="agreedOnSchedule"
          (ionChange)="setOrResetValue($event)"
        >
        </mb-radio-group>
        <div class="warn">
          <p *ngIf="form.get('agreedOnSchedule').errors?.required">Please select an option.</p>
        </div>
      </mable-input>

      <mable-input
        label="Expected start date "
        icon="calendar"
        icon-slot="end"
        *ngIf="form.get('agreedOnSchedule').value"
      >
        <mable-date
          formControlName="expectedStartDate"
          max="{{ currentYear + 10 }}"
        ></mable-date>
      </mable-input>
      <mable-input
        label="Start time "
        icon="calendar"
        icon-slot="end"
        *ngIf="form.get('agreedOnSchedule').value && form.get('jobFrequency').value === 'once_off'"
      >
        <mable-time
          [minuteValues]="minutes"
          formControlName="expectedStartTime"
        ></mable-time>
      </mable-input>
      <mable-input
        label="How often will you provide support?"
        [hasError]="form.controls.jobOccurrence.showError()"
        *ngIf="form.get('agreedOnSchedule').value && form.get('jobFrequency').value === 'ongoing'"
      >
        <ion-select
          aria-label="How often will you provide support?"
          formControlName="jobOccurrence"
          (ionChange)="toggleValidationScheduleDescription()"
        >
          <ion-select-option value="weekly">Weekly</ion-select-option>
          <ion-select-option value="fortnightly">Fortnightly</ion-select-option>
          <ion-select-option value="monthly">Monthly</ion-select-option>
          <ion-select-option value="other">Other</ion-select-option>
        </ion-select>
        <div class="warn">
          <p *ngIf="form.get('jobOccurrence').errors?.required">Please select a option.</p>
        </div>
      </mable-input>
      <mable-input
        label="Session dates and times"
        [hasError]="form.get('scheduleDescription').showError()"
        *ngIf="
          form.get('agreedOnSchedule').value &&
          form.get('jobOccurrence').value !== 'weekly' &&
          form.get('jobFrequency').value === 'ongoing'
        "
      >
        <p class="description">
          Add timing details of your support sessions. For example, 9am to 11am every fortnight.
        </p>
        <ion-textarea
          autocapitalize="sentences"
          rows="4"
          formControlName="scheduleDescription"
          autocomplete="on"
          autocorrect="on"
          spellcheck="true"
        >
        </ion-textarea>
        <p
          class="warn"
          *ngIf="form.get('scheduleDescription').errors?.required"
        >
          Please enter schedule Description
        </p>
      </mable-input>
      <!-- Weekly days and time section -->
      <div
        formGroupName="daysAndTimes"
        novalidate
        id="daysTimeSection"
        *ngIf="
          form.get('agreedOnSchedule').value &&
          form.get('jobOccurrence').value === 'weekly' &&
          form.get('jobFrequency').value === 'ongoing'
        "
      >
        <ion-label class="form-label-18 ion-padding-horizontal"> Expected days and times (optional) </ion-label>
        <ion-list class="ion-margin-horizontal">
          <ng-container
            *ngFor="let day of weekDaysOptions"
            [formGroupName]="day"
          >
            <ion-item
              [lines]="form['controls'].daysAndTimes.get(day).value.expected ? 'none' : 'full'"
              class="listItem ion-no-padding"
            >
              <ion-toggle
                formControlName="expected"
                (ionChange)="initOrClearTimeSlotsForDay(day, $event?.detail?.checked)"
              >
                <h4 class="small emphasise ion-no-margin">{{ day | titlecase }}</h4>
              </ion-toggle>
            </ion-item>
            <div
              class="border-vertical day"
              *ngIf="form['controls'].daysAndTimes.get(day).value.expectedSessions.length > 0"
            >
              <ng-container formArrayName="expectedSessions">
                <span class="screen-reader-only"> Time slots for {{ day }} </span>
                <ng-container
                  *ngFor="
                    let timeSession of form['controls'].daysAndTimes.get(day)['controls']?.expectedSessions['controls'];
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <ion-item lines="none">
                    <span class="screen-reader-only"> {{ day }} time slot {{ i + 1 }} </span>
                    <ion-grid class="no-padding">
                      <ion-row class="no-margin">
                        <ion-col
                          size="5"
                          class="ion-no-padding"
                        >
                          <mable-input
                            label="Start time"
                            class="ion-no-margin"
                            [hasError]="timeSession.get('startAt').showError()"
                          >
                            <mable-time
                              [minuteValues]="minutes"
                              formControlName="startAt"
                            ></mable-time>

                            <div class="warn">
                              <p *ngIf="timeSession.get('startAt').errors?.required">Please select a time.</p>
                            </div>
                          </mable-input>
                        </ion-col>
                        <ion-col
                          size="5"
                          class="ion-no-padding"
                        >
                          <mable-input
                            label="End time"
                            class="ion-no-margin"
                            [hasError]="timeSession.get('endAt').showError()"
                          >
                            <mable-time
                              [minuteValues]="minutes"
                              formControlName="endAt"
                            ></mable-time>

                            <div class="warn">
                              <p *ngIf="timeSession.get('endAt').errors?.required">Please select a time.</p>
                            </div>
                          </mable-input>
                        </ion-col>
                        <ion-col
                          size="2"
                          class="ion-no-padding trash"
                        >
                          <mable-button
                            icon="trash"
                            category="link"
                            ariaLabel="remove time"
                            *ngIf="i > 0"
                            (onClick)="removeExpectedHoursSlotForTheDay(day, i)"
                          >
                          </mable-button>
                        </ion-col>
                        <div
                          class="errorMessage"
                          *ngIf="timeSession?.errors?.isNotValidTimeSlot"
                        >
                          <ion-icon
                            slot="start"
                            name="alert-circle"
                          ></ion-icon>
                          <p class="warn">Enter start time earlier than end time.</p>
                        </div>
                      </ion-row>
                    </ion-grid>
                  </ion-item>
                </ng-container>
                <!--
                  createExpectedTimeSlotForTheDay currently takes null as a workaround to avoid template errors.
                  This functionality will be removed / refactored in future as part of ES-30770.
                -->
                <mable-button
                  icon="add"
                  class="ion-no-padding"
                  category="clear-purple"
                  ariaLabel="add another time"
                  (onClick)="createExpectedTimeSlotForTheDay(day, null)"
                  >Add another time
                </mable-button>
                <div
                  class="errorMessage"
                  *ngIf="
                    form['controls'].daysAndTimes.get(day)['controls']?.expectedSessions?.errors?.isTimeSlotsOverlapping
                  "
                >
                  <ion-icon
                    slot="start"
                    name="alert-circle"
                  ></ion-icon>
                  <p class="warn">Times can't overlap. Please use different time.</p>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ion-list>
      </div>
      <!-- Section end -->
      <mable-input
        label="Expected end date (optional)"
        icon="calendar"
        icon-slot="end"
        *ngIf="form.get('agreedOnSchedule').value && form.get('jobFrequency').value === 'ongoing'"
      >
        <mable-date
          formControlName="expectedEndDate"
          max="{{ currentYear + 10 }}"
        ></mable-date>
      </mable-input>
    </ng-container>
  </form>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <mable-button
      size="large"
      expand="block"
      buttonType="submit"
      (onClick)="submit()"
      ariaLabel="Proceed to next step 3"
      data-testid="agreement-form-step2-next-button"
      >Next</mable-button
    >
  </ion-toolbar>
</ion-footer>
